// Abre el calendario/reloj nativo al tocar cualquier parte de un campo de fecha u hora.
//
// En varios WebViews (y en escritorio) el input[type=date|time] solo abre el selector al
// tocar su icono; tocar el texto o el padding del contenedor (IonItem, TextField de MUI)
// no hace nada. Un único listener global cubre todos los campos de la app, incluidos
// IonInput (que renderiza un <input> nativo adentro) y TextField.

const TIPOS = new Set(["date", "time", "datetime-local", "month", "week"]);

// Contenedores que "pertenecen" a un único campo: tocar su padding o su etiqueta abre el
// selector del input que contienen.
const CONTENEDORES = "ion-item, ion-input, .MuiInputBase-root, .MuiTextField-root, label";

// Elementos interactivos propios que no deben disparar el selector del campo vecino.
const INTERACTIVOS = "button, a, select, textarea, ion-button, ion-select, ion-checkbox, ion-toggle, ion-radio, ion-datetime";

type InputConPicker = HTMLInputElement & { showPicker?: () => void };

const esCampoFechaHora = (el: Element | null): el is InputConPicker =>
  el instanceof HTMLInputElement && TIPOS.has(el.type);

const buscarCampo = (target: Element): InputConPicker | null => {
  if (esCampoFechaHora(target)) return target;
  if (target instanceof HTMLInputElement) return null;
  if (target.closest(INTERACTIVOS)) return null;

  // Subimos por contenedores hasta el primero que tenga inputs: la etiqueta de un
  // TextField es un <label> hermano del input, sin inputs propios.
  let contenedor = target.closest(CONTENEDORES);
  while (contenedor) {
    const inputs = contenedor.querySelectorAll("input");
    if (inputs.length > 0) {
      // Solo si el contenedor tiene un único input y es de fecha/hora (evita ambigüedad).
      if (inputs.length !== 1) return null;
      return esCampoFechaHora(inputs[0]) ? inputs[0] : null;
    }
    contenedor = contenedor.parentElement?.closest(CONTENEDORES) ?? null;
  }
  return null;
};

const alTocar = (event: MouseEvent) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const input = buscarCampo(target);
  if (!input || input.disabled || input.readOnly) return;

  if (typeof input.showPicker === "function") {
    try {
      input.showPicker();
      return;
    } catch {
      // Sin gesto de usuario válido o picker ya abierto: queda el comportamiento nativo.
    }
  }
  if (target !== input) input.focus();
};

let registrado = false;

export const registrarAperturaSelectorFechaHora = () => {
  if (registrado || typeof document === "undefined") return;
  registrado = true;
  document.addEventListener("click", alTocar, true);
};
